<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle opacity="0.5" cx="12" cy="12" r="11.5" fill="white" stroke="#BE8682"/>
<g opacity="0.5">
<path d="M7.54169 11.5H17.4584" stroke="#BE8682" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.5 6.5415L17.4583 11.4998L12.5 16.4582" stroke="#BE8682" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
